import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions/fnbAction';
import * as service from '../services/fnbService';
import i18n from '../constants/initLng';
import * as Func from '../helpers/functions';
import { menuAutoTranslateRequest } from 'actions/autoTranslateAction';
// import { toastError, toastSuccess } from '../helpers/ToastHelper'; // Assuming ToastHelper exists, check imports



function* getOutletsSaga(action) {
    try {
        const payload = action.payload || {};
        const params = payload.params || payload;
        const data = yield call(service.getOutlets, params);
        yield put(actions.getOutletsSuccess({
            items: data.items || [],
            pagination: data.pagination || null,
            append: Boolean(payload.append),
        }));
    } catch (error) {
        yield put(actions.getOutletsFail(error));
    }
}

function* getPropertiesSaga(action) {
    try {
        const data = yield call(service.getProperties, action.payload);
        yield put(actions.getPropertiesSuccess(data || []));
    } catch (error) {
        yield put(actions.getPropertiesFail(error));
    }
}

function* syncOutletsSaga(action) {
    try {
        const filters = action.payload?.filters || {};
        const syncPayload = action.payload?.syncPayload || { isFullSync: true };
        const data = yield call(service.syncOutlets, syncPayload);
        yield put(actions.syncOutletsSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.syncSuccess'));
        yield put(actions.getOutlets(filters));
    } catch (error) {
        yield put(actions.syncOutletsFail(error));
    }
}

function* updateOutletSaga(action) {
    try {
        const payload = action.payload || {};
        const updatePayload = payload.updatePayload || payload;
        yield call(service.updateOutlet, updatePayload);
        yield put(actions.updateOutletSuccess({ outletId: payload.outletId || updatePayload.id }));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
        yield put(actions.getOutlets(payload.filters || {}));
    } catch (error) {
        yield put(actions.updateOutletFail({
            error,
            outletId: action.payload?.outletId || action.payload?.updatePayload?.id,
        }));
    }
}

function* getMenusSaga(action) {
    try {
        const data = yield call(service.getMenus, action.payload);
        yield put(actions.getMenusSuccess(data));
    } catch (error) {
        yield put(actions.getMenusFail(error));
    }
}

function* syncMenusSaga(action) {
    try {
        const payload = action.payload || {};
        const outletId = payload.outletId;
        const propertyId = payload.propertyId;
        const filters = payload.filters || {};
        yield call(service.syncMenus, { outletId, propertyId });
        yield put(actions.syncMenusSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
        yield put(actions.getMenus(filters));
    } catch (error) {
        yield put(actions.syncMenusFail(error));
    }
}

function* syncMenuItemsSaga(action) {
    try {
        const payload = action.payload || {};
        const outletId = payload.outletId;
        const propertyId = payload.propertyId;
        const filters = payload.filters || {};
        yield call(service.syncMenuItems, { outletId, propertyId });
        yield put(actions.syncMenuItemsSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
        yield put(actions.getMenus(filters));
    } catch (error) {
        yield put(actions.syncMenuItemsFail(error));
    }
}

function* getMenuItemsSaga(action) {
    try {
        const data = yield call(service.getMenuItems, action.payload);
        yield put(actions.getMenuItemsSuccess(data));
    } catch (error) {
        yield put(actions.getMenuItemsFail(error));
    }
}

function* updateMenuItemSaga(action) {
    try {
        const payload = action.payload || {};
        yield call(service.updateMenuItem, payload.updatePayload || payload);
        yield put(actions.updateMenuItemSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
        if (payload.filters) {
            yield put(actions.getMenuItems(payload.filters));
        }
    } catch (error) {
        yield put(actions.updateMenuItemFail(error));
    }
}

function* getMenuDetailSaga(action) {
    try {
        const data = yield call(service.getMenuDetail, action.payload);
        yield put(actions.getMenuDetailSuccess(data));
    } catch (error) {
        yield put(actions.getMenuDetailFail(error));
        // toastError(error);
    }
}

function* updateMenuSaga(action) {
    try {
        const payload = action.payload || {};
        const data = yield call(service.updateMenu, payload.updatePayload || payload);
        yield put(actions.updateMenuSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
        if (payload.filters) {
            yield put(actions.getMenus(payload.filters));
        }
    } catch (error) {
        yield put(actions.updateMenuFail(error));
        // toastError(error);
    }
}

function* translateMenuSaga(action) {
    try {
        const payload = action.payload || {};
        const payloadWithoutLanguageName = {
            ...payload,
            languageName: undefined
        };
        const data = payload.id
            ? yield call(service.updateMenuTranslate, payloadWithoutLanguageName)
            : yield call(service.createMenuTranslate, payloadWithoutLanguageName);
        yield put(actions.translateMenuSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'), payload.languageName);
        if (payload.menuId || payload.fnbMenuId) {
            yield put(actions.getMenuDetail(payload.menuId || payload.fnbMenuId));
        }
    } catch (error) {
        yield put(actions.translateMenuFail(error));
    }
}

function* deleteMenuTranslateSaga(action) {
    try {
        const payload = action.payload || {};
        yield call(service.deleteMenuTranslate, payload.translateId);
        yield put(actions.deleteMenuTranslateSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), payload.languageName);
        if (payload.menuId) {
            yield put(actions.getMenuDetail(payload.menuId));
        }
    } catch (error) {
        yield put(actions.deleteMenuTranslateFail(error));
    }
}

function* getItemDetailSaga(action) {
    try {
        const data = yield call(service.getItemDetail, action.payload);
        yield put(actions.getItemDetailSuccess(data));
    } catch (error) {
        yield put(actions.getItemDetailFail(error));
    }
}

// Product Sagas
function* getProductsSaga(action) {
    try {
        const data = yield call(service.getProducts, action.payload);
        yield put(actions.getProductsSuccess(data));
    } catch (error) {
        yield put(actions.getProductsFail(error));
    }
}

function* syncProductsSaga(action) {
    try {
        const data = yield call(service.syncProducts, action.payload);
        if (data.data) {
            Func.sagaSuccessMessage(action, i18n.t('notification.syncSuccess'));
        }
        yield put(actions.syncProductsSuccess(data));
        yield put(actions.getProducts()); // Refresh list
    } catch (error) {
        yield put(actions.syncProductsFail(error));
    }
}

function* getProductDetailSaga(action) {
    try {
        const data = yield call(service.getProductDetail, action.payload);
        yield put(actions.getProductDetailSuccess(data));
    } catch (error) {
        yield put(actions.getProductDetailFail(error));
    }
}

function* updateProductSaga(action) {
    try {
        const payload = action.payload || {};
        const data = yield call(service.updateProduct, payload);
        yield put(actions.updateProductSuccess(data));
    } catch (error) {
        yield put(actions.updateProductFail(error));
    }
}

function* translateProductSaga(action) {
    try {
        const payload = action.payload || {};
        const requestPayload = {
            id: payload.id,
            fnbProductId: payload.id,
            name: payload.name,
            shortName: payload.shortName,
            description: payload.description,
            languageCode: payload.languageCode,
        };
        const data = payload.id && payload.isUpdate
            ? yield call(service.updateProductTranslate, { ...requestPayload, id: payload.translateId || payload.id })
            : yield call(service.createProductTranslate, requestPayload);
        
        yield put(actions.translateProductSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'), payload.languageName);
        if (payload.productId || payload.id) {
            yield put(actions.getProductDetail(payload.productId || payload.id));
        }
    } catch (error) {
        yield put(actions.translateProductFail(error));
    }
}

function* deleteProductTranslateByIdSaga(action) {
    try {
        const payload = action.payload || {};
        yield call(service.deleteProductTranslate, payload.translateId);
        yield put(actions.deleteProductTranslateByIdSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), payload.languageName);
        if (payload.productId) {
            yield put(actions.getProductDetail(payload.productId));
        }
    } catch (error) {
        yield put(actions.deleteProductTranslateByIdFail(error));
    }
}

function* getCondimentsSaga(action) {
    try {
        const data = yield call(service.getCondiments, action.payload);
        yield put(actions.getCondimentsSuccess(data));
    } catch (error) {
        yield put(actions.getCondimentsFail(error));
        // toastError(error);
    }
}

function* syncCondimentsSaga(action) {
    try {
        const payload = action.payload || {};
        const propertyId = payload.propertyId;
        const filters = payload.filters || {};
        yield call(service.syncCondiments, { propertyId });
        yield put(actions.syncCondimentsSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
        yield put(actions.getCondiments(filters));
    } catch (error) {
        yield put(actions.syncCondimentsFail(error));
    }
}

function* getCondimentDetailSaga(action) {
    try {
        const data = yield call(service.getCondimentDetail, action.payload);
        yield put(actions.getCondimentDetailSuccess(data));
    } catch (error) {
        yield put(actions.getCondimentDetailFail(error));
        // toastError(error);
    }
}

function* updateCondimentSaga(action) {
    try {
        const payload = action.payload || {};
        const data = yield call(service.updateCondiment, payload.updatePayload || payload);
        yield put(actions.updateCondimentSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
    } catch (error) {
        yield put(actions.updateCondimentFail(error));
        // toastError(error);
    }
}

function* translateCondimentSaga(action) {
    try {
        const payload = action.payload || {};
        const requestPayload = {
            id: payload.id,
            fnbProductCondimentId: payload.fnbProductCondimentId,
            name: payload.name,
            description: payload.description,
            languageCode: payload.languageCode,
        };
        const data = payload.id
            ? yield call(service.updateCondimentTranslate, requestPayload)
            : yield call(service.createCondimentTranslate, requestPayload);
        yield put(actions.translateCondimentSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'), payload.languageName);
        if (payload.condimentId || payload.fnbProductCondimentId) {
            yield put(actions.getCondimentDetail(payload.condimentId || payload.fnbProductCondimentId));
        }
    } catch (error) {
        yield put(actions.translateCondimentFail(error));
    }
}

function* deleteCondimentTranslateSaga(action) {
    try {
        const payload = action.payload || {};
        yield call(service.deleteCondimentTranslate, payload.translateId);
        yield put(actions.deleteCondimentTranslateSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), payload.languageName);
        if (payload.condimentId) {
            yield put(actions.getCondimentDetail(payload.condimentId));
        }
    } catch (error) {
        yield put(actions.deleteCondimentTranslateFail(error));
    }
}

function* getOptionsSaga(action) {
    try {
        const data = yield call(service.getOptions, action.payload);
        yield put(actions.getOptionsSuccess(data));
    } catch (error) {
        yield put(actions.getOptionsFail(error));
        // toastError(error);
    }
}

function* syncOptionsSaga(action) {
    try {
        const payload = action.payload || {};
        const propertyId = payload.propertyId;
        const filters = payload.filters || {};
        yield call(service.syncOptions, { propertyId });
        yield put(actions.syncOptionsSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
        yield put(actions.getOptions(filters));
    } catch (error) {
        yield put(actions.syncOptionsFail(error));
    }
}

function* getOptionDetailSaga(action) {
    try {
        const data = yield call(service.getOptionDetail, action.payload);
        yield put(actions.getOptionDetailSuccess(data));
    } catch (error) {
        yield put(actions.getOptionDetailFail(error));
        // toastError(error);
    }
}

function* updateOptionSaga(action) {
    try {
        const payload = action.payload || {};
        const data = yield call(service.updateOption, payload.updatePayload || payload);
        yield put(actions.updateOptionSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'));
    } catch (error) {
        yield put(actions.updateOptionFail(error));
        // toastError(error);
    }
}

function* translateOptionSaga(action) {
    try {
        const payload = action.payload || {};
        const requestPayload = {
            id: payload.id,
            fnbProductOptionId: payload.fnbProductOptionId,
            name: payload.name,
            description: payload.description,
            languageCode: payload.languageCode,
        };
        const data = payload.id
            ? yield call(service.updateOptionTranslate, requestPayload)
            : yield call(service.createOptionTranslate, requestPayload);
        yield put(actions.translateOptionSuccess(data));
        Func.sagaSuccessMessage(action, i18n.t('notification.updateSuccess'), payload.languageName);
        if (payload.optionId || payload.fnbProductOptionId) {
            yield put(actions.getOptionDetail(payload.optionId || payload.fnbProductOptionId));
        }
    } catch (error) {
        yield put(actions.translateOptionFail(error));
    }
}

function* deleteOptionTranslateSaga(action) {
    try {
        const payload = action.payload || {};
        yield call(service.deleteOptionTranslate, payload.translateId);
        yield put(actions.deleteOptionTranslateSuccess());
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), payload.languageName);
        if (payload.optionId) {
            yield put(actions.getOptionDetail(payload.optionId));
        }
    } catch (error) {
        yield put(actions.deleteOptionTranslateFail(error));
    }
}

export default function* fnbSaga() {
    yield takeLatest(actions.FNB_GET_OUTLETS, getOutletsSaga);
    yield takeLatest(actions.FNB_GET_PROPERTIES, getPropertiesSaga);
    yield takeLatest(actions.FNB_SYNC_OUTLETS, syncOutletsSaga);
    yield takeLatest(actions.FNB_UPDATE_OUTLET, updateOutletSaga);
    yield takeLatest(actions.FNB_GET_MENUS, getMenusSaga);
    yield takeLatest(actions.FNB_GET_MENU_ITEMS, getMenuItemsSaga);
    yield takeLatest(actions.FNB_UPDATE_MENU_ITEM, updateMenuItemSaga);
    yield takeLatest(actions.FNB_SYNC_MENUS, syncMenusSaga);
    yield takeLatest(actions.FNB_SYNC_MENU_ITEMS, syncMenuItemsSaga);
    yield takeLatest(actions.FNB_GET_MENU_DETAIL, getMenuDetailSaga);
    yield takeLatest(actions.FNB_UPDATE_MENU, updateMenuSaga);
    yield takeLatest(actions.FNB_MENU_TRANSLATE, translateMenuSaga);
    yield takeLatest(actions.FNB_MENU_TRANSLATE_DELETE, deleteMenuTranslateSaga);
    yield takeLatest(actions.FNB_GET_ITEM_DETAIL, getItemDetailSaga);
    yield takeLatest(actions.FNB_GET_CONDIMENTS, getCondimentsSaga);
    yield takeLatest(actions.FNB_SYNC_CONDIMENTS, syncCondimentsSaga);
    yield takeLatest(actions.FNB_GET_CONDIMENT_DETAIL, getCondimentDetailSaga);
    yield takeLatest(actions.FNB_UPDATE_CONDIMENT, updateCondimentSaga);
    yield takeLatest(actions.FNB_CONDIMENT_TRANSLATE, translateCondimentSaga);
    yield takeLatest(actions.FNB_CONDIMENT_TRANSLATE_DELETE, deleteCondimentTranslateSaga);
    yield takeLatest(actions.FNB_GET_OPTIONS, getOptionsSaga);
    yield takeLatest(actions.FNB_SYNC_OPTIONS, syncOptionsSaga);
    yield takeLatest(actions.FNB_GET_OPTION_DETAIL, getOptionDetailSaga);
    yield takeLatest(actions.FNB_UPDATE_OPTION, updateOptionSaga);
    // Products
    yield takeLatest(actions.FNB_GET_PRODUCTS, getProductsSaga);
    yield takeLatest(actions.FNB_SYNC_PRODUCTS, syncProductsSaga);
    yield takeLatest(actions.FNB_GET_PRODUCT_DETAIL, getProductDetailSaga);
    yield takeLatest(actions.FNB_UPDATE_PRODUCT, updateProductSaga);
    yield takeLatest(actions.FNB_OPTION_TRANSLATE, translateOptionSaga);
    yield takeLatest(actions.FNB_OPTION_TRANSLATE_DELETE, deleteOptionTranslateSaga);
    yield takeLatest(actions.FNB_PRODUCT_TRANSLATE, translateProductSaga);
    yield takeLatest(actions.FNB_PRODUCT_TRANSLATE_DELETE, deleteProductTranslateByIdSaga);
}
